module.exports = __webpack_public_path__ + "static/media/kalv-min.ea9c5ad9.png";